import $ from 'jquery';
import lottie from 'lottie-web';

const selector = 'cards-section';
const $section = $(`.${selector}`);
const $list = $section.find(`.${selector}__list`);

export default class CardsSection {
	constructor() {
		this.containers = $('.js-lottie-animation');
		this.animations = [];
	}

	checkOdd = () => {
		$list.removeClass(`${selector}__list_odd`);
		const $cards = $section.find(`.${selector}__card`);
		if ($cards.length % 2) {
			$list.addClass(`${selector}__list_odd`);
		}
	}

	initAnimation() {
		this.containers.map(id => {
			const container = this.containers.eq(id);
			const type = container.attr('data-anim-type');

			this.animations.push(
				lottie.loadAnimation({
					container: container[0], // the dom element that will contain the animation
					renderer: 'svg',
					loop: false,
					autoplay: false,
					path: `/bodymovin/anim${type}.json` // the path to the animation json
				})
			);

			if (window.innerWidth >= 1240) {
				container.on('mouseenter', () => this.frameLaunch(id));
				container.on('mouseleave', () => this.frameReverse(id));
			}
		});
	}

	frameLaunch(id) {
		const animation = this.animations[id];

		animation.setDirection(1);
		animation.goToAndPlay(0, true);
	}

	frameReverse(id) {
		const animation = this.animations[id];

		animation.pause();
		animation.setDirection(-1);
		animation.play();
	}

	static init() {
		const instance = new CardsSection();
		instance.checkOdd();
		instance.initAnimation();

		return instance;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/tournament-page/cards-section/index.js